import React, { useState } from 'react';
import {
  Input, Card, Button, Breadcrumb, Col, Row, Space, Spin, Select
} from 'antd';
import { useTranslation } from 'react-i18next';
import {
  PlusOutlined, SearchOutlined, RiseOutlined, FallOutlined,
} from '@ant-design/icons';  
import CenteredContent from '@common/components/ui/CenteredContent';
import { Link } from 'react-router-dom';
import useDashboardRoot from './useDashboardRoot';
import styles from './DashboardRoot.module.less';

import { ReactComponent as companyIcon } from '@assets/svg/company.svg';
import { ReactComponent as energyIcon } from '@assets/svg/energy.svg';
import Icon from '@ant-design/icons/lib/components/Icon';

import Map from '@common/components/map/GoogleMap';
 

const { Search } = Input;
const { Option, OptGroup } = Select;

const style = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: 25,
  marginTop: 25,
  cursor: 'pointer',
};

function DashboardRoot() {

  const { t } = useTranslation();
  const {
    loading, loadingBusiness
  } = useDashboardRoot();
 

  return (
    <div>
      {loading ? (
        <>
          <CenteredContent>
            <Spin tip={t('views.device_graphics.loading_data_graphs')} />
          </CenteredContent>
        </>
      ) : (
        <>
          <Row>
              <Col span={18} style={{ padding: '0.95rem 0.45rem 0.95rem 0' }}>
              <Row>
                <Col span={24} style={{ padding: '.95rem' }}>
                  <Card style={{ width: '100%' }}>
                    <Row>
                      <Col xs={24} sm={24} md={20} lg={20} xl={20}>
                        <Row className="miga_title">{t('common.welcome')}</Row>
                        <Row style={{ fontSize: '14px', color: '#8c8c8c' }}>
                          <Breadcrumb className={styles.date_wrapper}>
                            <Breadcrumb.Item className={styles.breadcrumb}>
                              <Link to="/">{t('menu_items.main.home')}</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item className={styles.breadcrumb}>
                              Línea de negocio
                            </Breadcrumb.Item>
                          </Breadcrumb>
                        </Row>
                      </Col>
                      <Col xs={24} sm={24} md={4} lg={4} xl={4} className="text-right">
                        <Button type="primary" style={{ float: 'right', padding: '.5rem 1rem 1.8rem', width: '100%' }}>
                          <PlusOutlined />
                          {` ${t('common.btn_create_bussiness')}`}
                        </Button>
                      </Col>
                    </Row>
                    <Row gutter={8}>
                      <Col xs={24} sm={24} md={24} lg={14} xl={14} style={{ display: 'flex', marginTop: '1rem' }}>
                        <Input
                          size="large"
                          placeholder={t('common.search_business')}
                          prefix={<SearchOutlined />}
                          style={{}}
                        />
                      </Col>
                      <Col xs={24} sm={24} md={24} lg={9} xl={9} style={{ marginTop: '1rem' }}>
                        <Button style={{ padding: '.5rem 1rem 1.8rem', marginLeft: 15, marginTop:5 }}>Todos</Button>

                        <Button style={{ padding: '.5rem 1rem 1.8rem', marginLeft: 15, marginTop:5 }}>Retail</Button>

                        <Button style={{ padding: '.5rem 1rem 1.8rem', marginLeft: 15, marginTop:5 }}>Comunidades</Button>

                      </Col> 
                        
                    </Row>
                  </Card>
                </Col>
              </Row>
              <Row>
                {
                  loadingBusiness ? (
                    <Row style={{
                      width: '100%', magin: 'auto', display: 'flex', justifyContent: 'center', justifyItems: 'center',
                    }}
                    >
                      <Col style={{ justifyContent: 'center', marginTop: '5%' }}>
                        <Spin tip={t('views.device_graphics.loading_data_graphs')} />
                      </Col>
                    </Row>
                  ) : (<>
                      <Col key={1} xs={24} sm={16} md={12} lg={8} xl={6}>
                        <div style={style}>
                          <Card style={{ width: '90%' }}>
                            <div style={{
                              fontSize: 18, fontWeight: 'bold', marginBottom: 10, color: '#000000',
                            }}
                            >

                              <Icon component={companyIcon} style={{ fontSize: 20, color: '#787878', marginRight: '1rem' }} />
                                
                              <span>Boca del Palo</span>
                            </div>
                            <div>
                              <p style={{ minHeight: '44px', color: '#8c8c8c' }}>ILorem ipsum dolor sit amet, consectetur adipiscing elit, sed do...</p>
                              <div style={{ borderRadius: 10 }}>
                                <Row>
                                  <Col span={24}>
                                    <div style={{ marginBottom: 10 }}>
                                      <div style={{ fontSize: 18, fontWeight: 'bold' }}>
                                        {t('common.devices')}
                                      </div>
                                    </div>
                                    <ul>
                                      <li style={{ marginBottom: 10, color: '#8c8c8c' }}>
                                        {t('common.totals')}
                                        <span
                                          style={{ fontSize: 14, float: 'right', color: '#000000' }}
                                        >
                                          20
                                        </span>
                                      </li>
                                      <li style={{ marginBottom: 10, color: '#8c8c8c' }}>
                                        {t('common.connecteds')}
                                        <span
                                          style={{ fontSize: 14, float: 'right', color: '#000000' }}
                                        >
                                          10
                                        </span>
                                      </li>
                                    </ul>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Card>
                        </div>
                      </Col>

                      <Col key={1} xs={24} sm={16} md={12} lg={8} xl={6}>
                        <div style={style}>
                          <Card style={{ width: '90%' }}>
                            <div style={{
                              fontSize: 18, fontWeight: 'bold', marginBottom: 10, color: '#000000',
                            }}
                            >

                              <Icon component={companyIcon} style={{ fontSize: 20, color: '#787878', marginRight: '1rem' }} />
                                
                              <span>Boca del Palo 2</span>
                            </div>
                            <div>
                              <p style={{ minHeight: '44px', color: '#8c8c8c' }}>ILorem ipsum dolor sit amet, consectetur adipiscing elit, sed do...</p>
                              <div style={{ borderRadius: 10 }}>
                                <Row>
                                  <Col span={24}>
                                    <div style={{ marginBottom: 10 }}>
                                      <div style={{ fontSize: 18, fontWeight: 'bold' }}>
                                        {t('common.devices')}
                                      </div>
                                    </div>
                                    <ul>
                                      <li style={{ marginBottom: 10, color: '#8c8c8c' }}>
                                        {t('common.totals')}
                                        <span
                                          style={{ fontSize: 14, float: 'right', color: '#000000' }}
                                        >
                                          20
                                        </span>
                                      </li>
                                      <li style={{ marginBottom: 10, color: '#8c8c8c' }}>
                                        {t('common.connecteds')}
                                        <span
                                          style={{ fontSize: 14, float: 'right', color: '#000000' }}
                                        >
                                          10
                                        </span>
                                      </li>
                                    </ul>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Card>
                        </div>
                      </Col>

                      <Col key={1} xs={24} sm={16} md={12} lg={8} xl={6}>
                        <div style={style}>
                          <Card style={{ width: '90%' }}>
                            <div style={{
                              fontSize: 18, fontWeight: 'bold', marginBottom: 10, color: '#000000',
                            }}
                            >

                              <Icon component={energyIcon} style={{ fontSize: 20, color: '#787878', marginRight: '1rem' }} />
                                
                              <span>Ground</span>
                            </div>
                            <div>
                              <p style={{ minHeight: '44px', color: '#8c8c8c' }}>ILorem ipsum dolor sit amet, consectetur adipiscing elit, sed do...</p>
                              <div style={{ borderRadius: 10 }}>
                                <Row>
                                  <Col span={24}>
                                    <div style={{ marginBottom: 10 }}>
                                      <div style={{ fontSize: 18, fontWeight: 'bold' }}>
                                        {t('common.devices')}
                                      </div>
                                    </div>
                                    <ul>
                                      <li style={{ marginBottom: 10, color: '#8c8c8c' }}>
                                        {t('common.totals')}
                                        <span
                                          style={{ fontSize: 14, float: 'right', color: '#000000' }}
                                        >
                                          20
                                        </span>
                                      </li>
                                      <li style={{ marginBottom: 10, color: '#8c8c8c' }}>
                                        {t('common.connecteds')}
                                        <span
                                          style={{ fontSize: 14, float: 'right', color: '#000000' }}
                                        >
                                          10
                                        </span>
                                      </li>
                                    </ul>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Card>
                        </div>
                      </Col> 

                      <Col key={1} xs={24} sm={16} md={12} lg={8} xl={6}>
                        <div style={style}>
                          <Card style={{ width: '90%' }}>
                            <div style={{
                              fontSize: 18, fontWeight: 'bold', marginBottom: 10, color: '#000000',
                            }}
                            >

                              <Icon component={energyIcon} style={{ fontSize: 20, color: '#787878', marginRight: '1rem' }} />
                                
                              <span>Comunidad 18</span>
                            </div>
                            <div>
                              <p style={{ minHeight: '44px', color: '#8c8c8c' }}>ILorem ipsum dolor sit amet, consectetur adipiscing elit, sed do...</p>
                              <div style={{ borderRadius: 10 }}>
                                <Row>
                                  <Col span={24}>
                                    <div style={{ marginBottom: 10 }}>
                                      <div style={{ fontSize: 18, fontWeight: 'bold' }}>
                                        {t('common.devices')}
                                      </div>
                                    </div>
                                    <ul>
                                      <li style={{ marginBottom: 10, color: '#8c8c8c' }}>
                                        {t('common.totals')}
                                        <span
                                          style={{ fontSize: 14, float: 'right', color: '#000000' }}
                                        >
                                          20
                                        </span>
                                      </li>
                                      <li style={{ marginBottom: 10, color: '#8c8c8c' }}>
                                        {t('common.connecteds')}
                                        <span
                                          style={{ fontSize: 14, float: 'right', color: '#000000' }}
                                        >
                                          10
                                        </span>
                                      </li>
                                    </ul>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Card>
                        </div>
                      </Col> 
                      
                      <Col key={1} xs={24} sm={16} md={12} lg={8} xl={6}>
                        <div style={style}>
                          <Card style={{ width: '90%' }}>
                            <div style={{
                              fontSize: 18, fontWeight: 'bold', marginBottom: 10, color: '#000000',
                            }}
                            >

                              <Icon component={energyIcon} style={{ fontSize: 20, color: '#787878', marginRight: '1rem' }} />
                                
                              <span>Ground 1</span>
                            </div>
                            <div>
                              <p style={{ minHeight: '44px', color: '#8c8c8c' }}>ILorem ipsum dolor sit amet, consectetur adipiscing elit, sed do...</p>
                              <div style={{ borderRadius: 10 }}>
                                <Row>
                                  <Col span={24}>
                                    <div style={{ marginBottom: 10 }}>
                                      <div style={{ fontSize: 18, fontWeight: 'bold' }}>
                                        {t('common.devices')}
                                      </div>
                                    </div>
                                    <ul>
                                      <li style={{ marginBottom: 10, color: '#8c8c8c' }}>
                                        {t('common.totals')}
                                        <span
                                          style={{ fontSize: 14, float: 'right', color: '#000000' }}
                                        >
                                          20
                                        </span>
                                      </li>
                                      <li style={{ marginBottom: 10, color: '#8c8c8c' }}>
                                        {t('common.connecteds')}
                                        <span
                                          style={{ fontSize: 14, float: 'right', color: '#000000' }}
                                        >
                                          10
                                        </span>
                                      </li>
                                    </ul>
                                  </Col>
                                </Row>
                              </div>
                            </div>
                          </Card>
                        </div>
                      </Col> 

                    </> 
                  )
                }
              </Row>
              </Col>

              <Col span={6} style={{ padding: '0.95rem 0 0.95rem 0.45rem' }}>
              <Row>
                <Col span={24} style={{ padding: '.95rem' }}>
                  <Card style={{ width: '100%' }}>
                    <Row>
                      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                          <Row className="miga_title">Métricas</Row> 
                      </Col>
                      
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
                          <p style={{ minHeight: '44px', color: '#8c8c8c', marginTop: 5 }}>Enero 01 - Ene 24</p>
                      </Col>

                      <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
                        <Select className={styles.select_attribute} value={'mes'}>
                          <Option key={`mes`} value={'mes'}>{'Mes'}</Option> 
                        </Select>
                      </Col>

                      <Row> 
                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                              <div className={styles.cardCustom}>
                                <RiseOutlined  style={{fontSize:25, color:'#ff812e'}} /> <span className='miga_title'>420.000</span> <span className={styles.cardText}>kwh</span><br></br>
                                <span>Energía solar generada</span>
                              </div>
                            </Col>

                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                            <div className={styles.cardCustom}>
                                <FallOutlined  style={{fontSize:25, color:'#39587d'}} /> <span className='miga_title'>284.430</span> <span className={styles.cardText}>kwh</span><br></br>
                                <span>Energía Consumida</span>
                              </div>
                            </Col>

                            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                              <div className={styles.cardCustom}>
                                <RiseOutlined  style={{fontSize:25, color:'#ff812e'}} /> <span className='miga_title'>135.570</span> <span className={styles.cardText}>cop</span><br></br>
                                <span>Ganancia generadas</span>
                              </div>
                            </Col> 
                      </Row>

                    </Row> 
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col span={24} style={{ padding: '.95rem' }}>
                  <Card style={{ width: '100%', height:350}}>
                    
                      <div className="container_map" style={{height:300}}>
                        <Map>
                          <></>
                        </Map>
                      </div>
                      
                  </Card>
                </Col>
              </Row>
              </Col>
            
          </Row>
        </>
      )}
    </div>
  );

}

export default DashboardRoot;
